import { render, staticRenderFns } from "./BnftrcrdMgmt.vue?vue&type=template&id=7046fea9&"
import script from "./BnftrcrdMgmt.vue?vue&type=script&lang=js&"
export * from "./BnftrcrdMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports